export const mapRowSpecialityIdToName = (id: string, label: string, populationCategoriesMapToId: {id: string, label: string, name: string}[]) :string => {
    return populationCategoriesMapToId.find((item) => `${item.id}${item.label.toLowerCase()}` === `${id}${label.toLowerCase()}`).name
}
